import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Switch } from 'antd';
import AntdProForm, {
  ProFormText,
  ProFormTextArea,
} from '@ant-design/pro-form';
import ProForm from '../../layout/ProForm';
import RolePremissionForm from './RolePremissionsForm';

const { Text } = Typography;

const RoleForm = ({ onFinish, initialValues, showDisable }) => {
  const [form] = AntdProForm.useForm();
  return (
    <ProForm form={form} onFinish={onFinish} initialValues={initialValues}>
      <ProFormText
        width="xl"
        name="name"
        label="Name"
        rules={[{ required: true, message: 'Please enter role name!' }]}
      />
      <ProFormTextArea width="xl" name="description" label="Description" />
      <AntdProForm.Item
        name="isDefaultRoleForNewUser"
        label="Is default role for new user"
        valuePropName="checked"
        rules={[{ required: true }]}
      >
        <Switch />
      </AntdProForm.Item>
      {showDisable && (
        <AntdProForm.Item name="active" label="Active" valuePropName="checked">
          <Switch />
        </AntdProForm.Item>
      )}
      <Text>Premissions</Text>
      <RolePremissionForm />
    </ProForm>
  );
};

RoleForm.defaultProps = {
  initialValues: {
    isDefaultRoleForNewUser: false,
  },
  showDisable: false,
};

RoleForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  showDisable: PropTypes.bool.isRequired,
  initialValues: PropTypes.object.isRequired,
};

export default RoleForm;
